<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('banco-de-livros')" class="main">
      <b-container fluid="lg">
        <b-card no-body class="shadow-sm card_sistemacpv p-4">
          <b-row>
            <b-col cols="12" class="mt-1 mb-1" v-for="(material, index) in lists" :key="index">
              <b-link :href="material.LinkFree">
                <b-card no-body class="p-3 card_sistemacpv border-light">
                  <div class="d-flex align-items-center">
                    <i class="fa-light fa-book fa-xl mr-2"></i>
                    <span>{{ material.title }}</span>
                  </div>
                </b-card>
              </b-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>  
export default {
  data() {
    return {
      pageTitle: 'Banco de Livros',
      pageSubtitle: 'Ensino Médio - 2º Ano',
      NamePermission: '',
      IndexPermission: '',
      lists: [
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/capitaes-da-areia_jorge_amado.pdf',
          videoId: '',
          src: '',
          segment: '2',
          bundle: 'books',
          title: 'Capitães da Areia',
          discipline: 'Capitães da Areia',
          description: 'Ensino Médio',
          toolTip: ' ',
          anoSerie: '2ª série',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/dom_casmurro_Machado_de_Assis.pdf',
          videoId: '',
          src: '',
          segment: '2',
          bundle: 'books',
          title: 'Dom Casmurro',
          discipline: 'Dom Casmurro',
          description: 'Ensino Médio',
          toolTip: ' ',
          anoSerie: '2ª série',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/lira_dos_vinte_anos_Alvares_Azevedo.pdf',
          videoId: '',
          src: '',
          segment: '2',
          bundle: 'books',
          title: 'Lira dos Vinte Anos',
          discipline: 'Lira dos Vinte Anos',
          description: 'Ensino Médio',
          toolTip: ' ',
          anoSerie: '2ª série',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/macunaima_mario_de_andrade.pdf',
          videoId: '',
          src: '',
          segment: '2',
          bundle: 'books',
          title: 'Macunaíma - Mario de Andrade',
          discipline: 'Macunaíma - Mario de Andrade',
          description: 'Ensino Médio',
          toolTip: ' ',
          anoSerie: '2ª série',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/manuelzao_e_miguilim_J%20o%C3%A3o_Guimar%C3%A3es_Rosa.pdf',
          videoId: '',
          src: '',
          segment: '2',
          bundle: 'books',
          title: 'Manuelzão e Miguilim - João Guimarães Rosa<',
          discipline: 'Manuelzão e Miguilim - João Guimarães Rosa<',
          description: 'Ensino Médio',
          toolTip: ' ',
          anoSerie: '2ª série',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/memorias_postumas_de_bras_cubas_Machado_de_Assis.pdf',
          videoId: '',
          src: '',
          segment: '2',
          bundle: 'books',
          title: 'Memórias Póstumas de Brás Cubas',
          discipline: 'Memórias Póstumas de Brás Cubas',
          description: 'Ensino Médio',
          toolTip: ' ',
          anoSerie: '2ª série',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/morte_e_vida_severina_Joao_Cabral_de_Melo_Neto.pdf',
          videoId: '',
          src: '',
          segment: '2',
          bundle: 'books',
          title: 'Morte e Vida Severina',
          discipline: 'Morte e Vida Severina',
          description: 'Ensino Médio',
          toolTip: ' ',
          anoSerie: '2ª série',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/o-cortico_Aluisio_Azevedo.pdf',
          videoId: '',
          src: '',
          segment: '2',
          bundle: 'books',
          title: 'O Cortiço',
          discipline: 'O Cortiço',
          description: 'Ensino Médio',
          toolTip: ' ',
          anoSerie: '2ª série',
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}
</style>